import Iconify from 'src/components/Iconify';
import { MKT_ANALYTICS_DESIGN as d } from '../MktAnalytics.design';

const PLATFORM_CONFIG = {
    instagram: {
        label: 'Instagram',
        icon: 'mdi:instagram',
        className: d.platformBadge.instagram
    },
    facebook: {
        label: 'Facebook',
        icon: 'mdi:facebook',
        className: d.platformBadge.facebook
    },
    google_ads: {
        label: 'Google Ads',
        icon: 'mdi:google-ads',
        className: d.platformBadge.google_ads
    }
};

export default function PlatformBadge({ platform }) {
    const config = PLATFORM_CONFIG[platform];
    if (!config) return null;

    return (
        <span className={config.className}>
            <Iconify icon={config.icon} width={14} />
            {config.label}
        </span>
    );
}
